export default "__VITE_ASSET__Ec_tz8sz__"